// Libraries
import { Icon, VStack } from '@chakra-ui/react';
// Config
import { colors } from '@themeFoundations/index';
// Types
import { RatingPaths, RatingsIconProps } from './RatingsIcon.type';

/**
 * Component that renders the Ratings A, B, C, D, E icons.
 * @component
 * @param {RatingsIconProps} props - The RatingsIconProps for the RatingsIcon component.
 * @param {Rating} props.rating - The rating key, which should be one of the keys defined in the Rating enum.
 * @param {boolean} props.dark - Determines if the dark theme should be used.
 * @returns {ReactElement} The RatingsIcon component.
 */
export const RatingsIcon = (props: RatingsIconProps) => {
  const { rating, dark, appended, prepended, ...rest } = props;
  const fill = dark ? colors.ratings[rating].dark : colors.ratings[rating].light;
  const color = dark ? 'white' : colors.ratings[rating].dark;

  return (
    <VStack>
      <Icon width='28' height='28' viewBox='0 0 28 28' id={`rating${rating}`} {...rest} color={color} fill='none'>
        {appended && <rect width='20' x='-8px' height='28' fill={fill} />}
        {prepended && <rect width='20' x='8px' height='28' fill={fill} />}
        <rect width='28' height='28' rx='6' fill={fill} />
        <path d={RatingPaths[rating]} fill='currentColor' />
      </Icon>
    </VStack>
  );
};
